module.exports = __webpack_public_path__ + "img/imgyongzjq-4.f30d919d.png";